import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import type {
  SafetyEventViewType} from 'src/app/safety-events/SafetyEventForm';
import {
  SafetyEventForm
} from 'src/app/safety-events/SafetyEventForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {SafetyEventRouteService} from 'src/shared/services/RouterService/SafetyEventRouteService';
import {SafetyEventDocumentTitle} from 'src/app/safety-events/safetyEventHelpers';

export const EditSafetyEventPage: React.FC = () => {
  useSetDocumentTitle(SafetyEventDocumentTitle);
  const {id} = useParams();

  const router = useMemo(
    () => new SafetyEventRouteService(true, 'edit', {view: 'content'}),
    []
  );

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.SafetyEvents}>
      <SafetyEventForm
        mode="edit"
        id={+id!}
        view={'content' as SafetyEventViewType}
        router={router}
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.SafetyEventEdit(':id'),
  element: <EditSafetyEventPage />,
  module: ModuleEnum.SafetyEvent,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

